import { type Action, handleActions } from 'redux-actions';
import { type StoreUIState } from '../../types/StoreState';
import { endModuleLoad, startModuleLoad } from '../actions';

const initialState: StoreUIState = {
  loadingModules: ['CashierPayApp'],
};

export const uiStateReducer = handleActions<StoreUIState, any>(
  {
    [startModuleLoad as any](state: StoreUIState, action: Action<string>) {
      return {
        ...state,
        loadingModules: state.loadingModules.includes(action.payload)
          ? state.loadingModules
          : [...state.loadingModules, action.payload],
      };
    },
    [endModuleLoad as any](state: StoreUIState, action: Action<string>) {
      return {
        ...state,
        loadingModules: state.loadingModules.filter((moduleName) => moduleName !== action.payload),
      };
    },
  },
  initialState,
);
